import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StepIndicatorProps {
  steps: string[];
  currentStepIndex: number;
  labels: Record<string, string>;
}

/**
 * Segment progress bar.
 * Each step is a bar that fills with ink as it's completed or active.
 */
export const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStepIndex,
  labels,
}) => {
  return (
    <div className="flex flex-col gap-3">
      {/* Segment bar */}
      <div className="flex gap-1">
        {steps.map((stepId, index) => {
          const isCompleted = index < currentStepIndex;
          const isCurrent = index === currentStepIndex;

          return (
            <div
              key={stepId}
              className={cn(
                'h-1 flex-1 transition-opacity',
                isCompleted || isCurrent ? 'bg-foreground' : 'bg-border',
                isCurrent ? 'opacity-60' : isCompleted ? 'opacity-100' : 'opacity-30'
              )}
            />
          );
        })}
      </div>

      {/* Step labels row */}
      <div className="flex items-center justify-between px-1">
        {steps.map((stepId, index) => {
          const isCompleted = index < currentStepIndex;
          const isCurrent = index === currentStepIndex;

          return (
            <div key={stepId} className="flex items-center gap-1">
              {isCompleted && <Check className="size-3 text-foreground" />}
              <span
                className={cn(
                  'text-xs whitespace-nowrap',
                  isCurrent ? 'font-medium text-foreground' : 'text-muted-foreground'
                )}
              >
                {labels[stepId] || stepId}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
